import API from '../Utils/API';

export const getLinkedAccount = (successCallback) => (dispatch) => {
  dispatch({ type: 'GET_LINKED_ACCOUNT_REQUEST' });
  API.get('api/fetch_linked_account')
    .then((response) => {
      dispatch({
        type: 'GET_LINKED_ACCOUNT_SUCCESS',
        payload: response.data,
      });
      successCallback && successCallback(response.data);
    })
    .catch((error) => {
      try {
        dispatch({
          type: 'GET_LINKED_ACCOUNT_FAILURE',
          payload: error.response.data,
        });
      } catch {}
    });
};

export const createLinkedAccount =
  (data, successCreateLinkedAccount, failureCreateLinkedAccount) =>
  (dispatch) => {
    dispatch({ type: 'CREATE_LINKED_ACCOUNT_REQUEST' });
    API.post('api/create_linked_account', data)
      .then((response) => {
        dispatch({
          type: 'CREATE_LINKED_ACCOUNT_SUCCESS',
          payload: response.data,
        });
        successCreateLinkedAccount && successCreateLinkedAccount();
      })
      .catch((error) => {
        dispatch({
          type: 'CREATE_LINKED_ACCOUNT_FAILURE',
          payload: error.response.data,
        });
        failureCreateLinkedAccount &&
          failureCreateLinkedAccount(error.response.data);
      });
  };

export const addExistingLinkedAccountId =
  (data, successCreateLinkedAccount, failureCreateLinkedAccount) =>
  (dispatch) => {
    dispatch({ type: 'ADD_EXISTING_LINKED_ACCOUNT_ID_REQUEST' });
    API.post('api/add_linked_account_id', data)
      .then((response) => {
        dispatch({
          type: 'ADD_EXISTING_LINKED_ACCOUNT_ID_SUCCESS',
          payload: response.data,
        });
        successCreateLinkedAccount && successCreateLinkedAccount();
      })
      .catch((error) => {
        dispatch({
          type: 'ADD_EXISTING_LINKED_ACCOUNT_ID_FAILURE',
          payload: error.response.data,
        });
        failureCreateLinkedAccount &&
          failureCreateLinkedAccount(error.response.data);
      });
  };

export const getStackHolderAccount = (successCallback) => (dispatch) => {
  dispatch({ type: 'GET_STACKHOLDER_ACCOUNT_REQUEST' });
  API.get('api/fetch_stakeholder')
    .then((response) => {
      dispatch({
        type: 'GET_STACKHOLDER_ACCOUNT_SUCCESS',
        payload: response.data,
      });
      successCallback && successCallback(response.data);
    })
    .catch((error) => {
      try {
        dispatch({
          type: 'GET_STACKHOLDER_ACCOUNT_FAILURE',
          payload: error.response.data,
        });
      } catch {}
    });
};

export const createStackholderAccount =
  (data, successCreateStackholderAccount, failureCreateStackholderAccount) =>
  (dispatch) => {
    dispatch({ type: 'CREATE_STACKHOLDER_ACCOUNT_REQUEST' });
    API.post('api/create_stakeholder_account', data)
      .then((response) => {
        dispatch({
          type: 'CREATE_STACKHOLDER_ACCOUNT_SUCCESS',
          payload: response.data,
        });
        successCreateStackholderAccount && successCreateStackholderAccount();
      })
      .catch((error) => {
        dispatch({
          type: 'CREATE_STACKHOLDER_ACCOUNT_FAILURE',
          payload: error.response.data,
        });
        failureCreateStackholderAccount &&
          failureCreateStackholderAccount(error.response.data);
      });
  };

export const getProductConfiguration = (successCallback) => (dispatch) => {
  dispatch({ type: 'GET_PRODUCT_CONFIGURATION_REQUEST' });
  API.get('api/fetch_product_configuration')
    .then((response) => {
      dispatch({
        type: 'GET_PRODUCT_CONFIGURATION_SUCCESS',
        payload: response.data,
      });
      successCallback && successCallback(response.data);
    })
    .catch((error) => {
      try {
        dispatch({
          type: 'GET_PRODUCT_CONFIGURATION_FAILURE',
          payload: error.response.data,
        });
      } catch {}
    });
};

export const createProductConfiguration =
  (
    data,
    successCreateProductConfiguration,
    failureCreateProductConfiguration
  ) =>
  (dispatch) => {
    dispatch({ type: 'CREATE_PRODUCT_CONFIGURATION_REQUEST' });
    API.post('api/product_configuration', data)
      .then((response) => {
        dispatch({
          type: 'CREATE_PRODUCT_CONFIGURATION_SUCCESS',
          payload: response.data,
        });
        successCreateProductConfiguration &&
          successCreateProductConfiguration();
      })
      .catch((error) => {
        dispatch({
          type: 'CREATE_PRODUCT_CONFIGURATION_FAILURE',
          payload: error.response.data,
        });
        failureCreateProductConfiguration &&
          failureCreateProductConfiguration(error.response.data);
      });
  };

export const updateProductConfiguration =
  (
    data,
    successUpdateProductConfiguration,
    failureUpdateProductConfiguration
  ) =>
  (dispatch) => {
    dispatch({ type: 'UPDATE_PRODUCT_CONFIGURATION_REQUEST' });
    API.post('api/update_product_configuration', data)
      .then((response) => {
        dispatch({
          type: 'UPDATE_PRODUCT_CONFIGURATION_SUCCESS',
          payload: response.data,
        });
        successUpdateProductConfiguration &&
          successUpdateProductConfiguration();
      })
      .catch((error) => {
        dispatch({
          type: 'UPDATE_PRODUCT_CONFIGURATION_FAILURE',
          payload: error.response.data,
        });
        failureUpdateProductConfiguration &&
          failureUpdateProductConfiguration(error.response.data);
      });
  };
